import axios from 'axios';

const UserApi = {};

const nonce = devsAccountingApi.nonce;


UserApi.user = async () => {
    let url = "/wp-json/devsaccounting/v1/auth-check/";
    try {
        const response = await axios.get(url, {
            headers: {
                'X-WP-Nonce': nonce
            }
        });
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

UserApi.logout = async () => {
    let url = "/wp-json/devsaccounting/v1/logout/";
    try {
        const response = await axios.post(url, {}, {
            headers: {
                'X-WP-Nonce': nonce, 
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
    } catch (error) {
        console.error("Logout failed:", error.response ? error.response.data : error);
    }
};

UserApi.login = async (credentials) => {
    const url = "/wp-json/devsaccounting/v1/login/"; 
    try {
        const response = await axios.post(url, credentials, {
            headers: {
                'X-WP-Nonce': nonce,
                'Content-Type': 'application/json',
            },
            withCredentials: true 
        });
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};




UserApi.updateUserMeta = async (data) => {
    const url = "/wp-json/devs-accounting/v1/update-user-meta"; 
    try {
        const response = await axios.post(url, data, {
            headers: {
                'X-WP-Nonce': nonce,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error updating user meta:", error);
        throw error;
    };

};

UserApi.getUserMeta = async (key) => {
    const url = `/wp-json/devs-accounting/v1/get-user-meta?key=${key}`;

    try {
        const response = await axios.get(url, {
            headers: {
                'X-WP-Nonce': nonce,
            }
        });

        if (response && response.data) {
            return response.data;
        } else {
            console.error('No data received');
            throw new Error('No data received');
        }
    } catch (error) {
        console.error("Error fetching user meta:", error);
        throw error;
    }
};


export default UserApi;